import GenericPokkService from "#/data-layer/GenericPokkService";

/**
 * Service for fetching a list of Breeds
 */
export class BreedingValuesBreedService extends GenericPokkService {
  constructor() {
    super({
      baseUrl: "/api/plemenske_vrednosti/pasma_sifra",
    });
  }

  /**
   * Constructs the API endpoint URL based on the baseUrl and any additional parts provided.
   *
   * @param  {...any} parts
   * @returns string - The constructed API endpoint URL.
   */
  #endpoint(...parts) {
    return [this.baseUrl, ...parts.filter(Boolean)].join("/");
  }

  async query() {
    return this.client
      .get(this.#endpoint())
      .then(({ data }) => {
        return data;
      })
      .catch((err) => {
        const { status, data } = err.response || {};

        throw {
          ...data,
          status,
          message: data?.resultMessages || err.message,
          response: err.response,
        };
      });
  }
}
